import { ParticipantEnum, ROUTES } from '@/constants/common';
import { useParticipant } from '@/providers/ParticipantProvider';

export const useSearchRoute = () => {
  const { participant } = useParticipant();

  return participant === ParticipantEnum.RESUME
    ? ROUTES.SEARCH_RESUMES
    : ROUTES.SEARCH_VACANCIES;
};
